import { createContext, useContext } from 'react'

type AppStateContextProps = {
  selectedDeclarantId: string | null
  setSelectedDeclarantId: (declarantId: string) => void
}

export const AppStateContext = createContext<AppStateContextProps>({
  selectedDeclarantId: null,
  setSelectedDeclarantId: () => {}
})

export const useAppState = () => {
  const context = useContext(AppStateContext)

  if (!context) {
    throw new Error('useAppState must be used within a AppStateProvider')
  }

  return {
    ...context
  }
}
